"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiUsersCurrentUserGet200ResponseToJSON = exports.ApiUsersCurrentUserGet200ResponseFromJSONTyped = exports.ApiUsersCurrentUserGet200ResponseFromJSON = exports.instanceOfApiUsersCurrentUserGet200Response = exports.ApiUsersCurrentUserGet200ResponseStoreRolesEnum = void 0;
var runtime_1 = require("../runtime");
/**
 * @export
 */
exports.ApiUsersCurrentUserGet200ResponseStoreRolesEnum = {
    Follower: 'follower',
    Analytics: 'analytics',
    Manager: 'manager',
    Admin: 'admin',
    Owner: 'owner'
};
/**
 * Check if a given object implements the ApiUsersCurrentUserGet200Response interface.
 */
function instanceOfApiUsersCurrentUserGet200Response(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfApiUsersCurrentUserGet200Response = instanceOfApiUsersCurrentUserGet200Response;
function ApiUsersCurrentUserGet200ResponseFromJSON(json) {
    return ApiUsersCurrentUserGet200ResponseFromJSONTyped(json, false);
}
exports.ApiUsersCurrentUserGet200ResponseFromJSON = ApiUsersCurrentUserGet200ResponseFromJSON;
function ApiUsersCurrentUserGet200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'email': !(0, runtime_1.exists)(json, 'email') ? undefined : json['email'],
        'role': !(0, runtime_1.exists)(json, 'role') ? undefined : json['role'],
        'storeRoles': !(0, runtime_1.exists)(json, 'store_roles') ? undefined : json['store_roles'],
    };
}
exports.ApiUsersCurrentUserGet200ResponseFromJSONTyped = ApiUsersCurrentUserGet200ResponseFromJSONTyped;
function ApiUsersCurrentUserGet200ResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'email': value.email,
        'role': value.role,
        'store_roles': value.storeRoles,
    };
}
exports.ApiUsersCurrentUserGet200ResponseToJSON = ApiUsersCurrentUserGet200ResponseToJSON;
